module.exports = __webpack_public_path__ + "img/TopMain_Mobile.a8767ead.png";